import { useEffect } from 'react';
import { useApiData } from '../api/hooks';
import { MY_DASHBOARDS_ENDPOINT, DASHBOARDS_CHANGED_EVENT } from '../utils/dashboards';

// Dashboards the signed-in user may open (includes the virtual "All Agents" entry when allowed).
// `dashboards` is null until the first response, then an array (possibly empty).
const useMyDashboards = () => {
	const { data, loading, error, refetch } = useApiData(MY_DASHBOARDS_ENDPOINT, []);

	// Another view (Manage Dashboards) changed the list - pick it up without a page reload.
	useEffect(() => {
		window.addEventListener(DASHBOARDS_CHANGED_EVENT, refetch);
		return () => window.removeEventListener(DASHBOARDS_CHANGED_EVENT, refetch);
	}, [refetch]);
	return { dashboards: data, loading, error, refetch };
};

export default useMyDashboards;
